import styled from 'styled-components';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

export const NameCell = styled.span`
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const SecondaryCell = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const CompletionCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const CompletionProgress = styled(LinearProgress).attrs({ variant: 'determinate' })`
  flex: 1;
  max-width: 100px;
  height: 6px;
  border-radius: 3px;
  background-color: ${({ theme }) => theme.palette.grey[200]};
  .${linearProgressClasses.bar} {
    border-radius: 3px;
  }
`;
